<template>
  <div>
     <Headers :title="title"></Headers>
    <mt-navbar v-model="selected">
      <mt-tab-item id="COMPANY">{{ $t('header').exhibitor}}</mt-tab-item>
      <mt-tab-item id="PRODUCT">{{$t('header').exhibits}}</mt-tab-item>
      <mt-tab-item id="VIDEO">{{$t('header').video}}</mt-tab-item>
    </mt-navbar>
    <mt-tab-container v-model="selected" class="tab-content-wrap">
      <mt-tab-container-item id="COMPANY" class="product-wrap">
        <van-row style="padding:0 .28rem .28rem .28rem">
            <van-col  class="exhibitior-wrap"  v-for="(item, index) in companiesList" :key="index" span="8" @click="toCompanyDetail(item.company_id, item.exhibition_id.id, item.instance_id)">
                <template>
                    <div class="exhibitior-wrap-img">
                        <img :src="item.company && item.company.logo_url || logo" alt="">
                    </div>
                    <div class="exhibitior-wrap-title">
                        <span class="exhibitior-wrap-title-name">{{language == 'zh'? item.company.name : item.company.locales.en.name}}</span>
                        <div class="palce-store">
                            <div class="palce">
                                <img class="palce-icon" src="~statics/mobileShouye/location.png" alt="">
                                <span class="palce-name">{{item.company.address}}</span>
                            </div>
                            <div v-if="item.is_store == 0" class="store" @click.stop="collect(item)">
                                <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                                <span class="store-name">{{$t("detail").collect}}</span>
                            </div>
                            <div v-else class="store" @click.stop="cancelCollect(item)">
                                <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                                <span class="store-name">{{$t("detail").uncollect}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
      </mt-tab-container-item>
      <mt-tab-container-item id="PRODUCT" class="product-wrap">
        <van-row style="padding:0 .28rem .28rem .28rem">
          <van-col  class="exhibitior-wrap"  v-for="(item, index) in productsList" :key="index" span="8" @click="goProductDetaile(item.exhibition_product_id, item.exhibition_id, item.company_id)">
              <template>
                  <div class="exhibitior-wrap-img">
                      <img class="productImg" :src="item.product.cn.main_image[0].url" alt="" />
                  </div>
                  <div class="exhibitior-wrap-title">
                      <span class="exhibitior-wrap-title-name">{{item.productName}}</span>
                      <div class="palce-store">
                          <div v-if="item.is_store == 0" class="store"  @click.stop="collectPro(item)">
                              <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                              <span class="store-name">{{$t('detail').collect}}</span>
                          </div>
                          <div v-else class="store" @click.stop="cancelCollectPro(item)">
                              <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                              <span class="store-name">{{$t('detail').uncollect}}</span>
                          </div>
                      </div>
                  </div>
              </template>
          </van-col>
        </van-row>
      </mt-tab-container-item>
      <mt-tab-container-item id="VIDEO" class="product-wrap">
        <van-row style="padding:0 .28rem 0 .28rem">
            <van-col  class="videos-wrap"  v-for="(item, index) in videsList" :key="index" span="8">
                <template>
                    <div class="exhibitior-wrap-img">
                      <video class="video" :src="item.resource.download_url" controls></video>
                    </div>
                    <div class="exhibitior-wrap-title">
                        <div class="palce-store">
                            <div class="palce">
                                <span class="palce-name">{{item.resource.name}}</span>
                            </div>
                            <!-- <div v-if="item.is_dir == 0" class="store" @click.stop="isCollectVideo(item)">
                                <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                                <span class="store-name">{{$t('detail').collect}}</span>
                            </div>
                            <div v-else class="store" @click.stop="noCollectVideo(item)">
                                <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                                <span class="store-name">{{$t('detail').uncollect}}</span>
                            </div> -->
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
import Headers from "../mobileExhibition/components/Headers";
import { all_exhibition_id } from "../../../utils/exhibitId"

export default {
    name: 'mobileInterestOrder',
    data() {
        return {
          logo: require("statics/no-logo-new.png"),
          selected: 'COMPANY',
          companiesList: [],
          productsList: [],
          videsList: [],
          isProductsList: false,
          isLoading: false
        }
    },
    computed: {
      language(){
          return localStorage.getItem('language') || 'zh'
      },
      title(){
          return  this.language == 'zh' ?  '收藏夹' : 'Favorites'
      },
      ...mapState(["userInfo","language"]),
    },
    // computed: {
    //   language(){
    //       return localStorage.getItem('language') || 'zh'
    //   },
    //   ...mapState(["userInfo","language"]),
    // },
    created () {
      this.getMarkExhibitor()
    },
    watch: {
      selected(currentTab) {
        if (currentTab === 'PRODUCT') {
          this.getMarkProduct()
        }
         if (currentTab === 'VIDEO') {
          this.getMarkVideo()
        }
      },
      isLoading(isLoading) {
        if (isLoading) {
          Indicator.open()
        } else {
          Indicator.close()
        }
      }
    },
    methods: {
      //展商
        getMarkExhibitor() {
            api.getMarkExhibitor({
                exhibition_id: all_exhibition_id
            }).then((res) => {
                if (res.res === 1) {
                    const lang = localStorage.getItem("language");
                    this.companiesList =
                        res.list.map((item) => {
                            return {
                                ...item,
                                // productName: lang === "zh" ? item.product.cn.name : item.product.en.name
                            };
                        }) || [];
                    console.log(this.companiesList)
                    this.noData = !this.companiesList.length;
                }
            });
        },
        toCompanyDetail(_id,_exhibition_id,_vhall_id) {
            this.$router.push({
            path: '/mobilezhanquDetaile',
            query: {
                company_id: _id,
                exhibition_id: _exhibition_id,
                instance_id: _vhall_id
            }
            })
        },
      // 展商收藏
        collect(item) {
            api.isCollectExhibitors({
                exhibition_id: item.exhibition_id.id,
                company_id:  item.company_id 
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    item.is_store = 1;
                    this.$notify({ type: 'success', message: '收藏成功' });
                }
            });
        },
        cancelCollect(item) {
            api.noCollectExhibitors({
                exhibition_id: item.exhibition_id.id,
                company_id:  item.company_id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    item.is_store = 0;
                    this.$notify("取消收藏");
                    this.getMarkExhibitor()
                }
            });
        },
      //展品
        getMarkProduct() {
            api.getMarkProduct({
                exhibition_id: all_exhibition_id
            }).then((res) => {
                if (res.res === 1) {
                    const lang = localStorage.getItem("language");
                    this.productsList =
                        res.list.map((item) => {
                            return {
                                ...item,
                                productName:  item.product.cn.name
                            };
                        }) || [];
                    console.log(this.productsList)
                    this.noData = !this.productsList.length;
                }
            });
        },
        goProductDetaile(_id,_exhibition_id,_company_id){
            this.$router.push({
                path: '/mobileAboutProductDetail',
                query: {
                    company_id: _company_id,
                    exhibition_id: _exhibition_id,
                    exhibition_product_id: _id
                }
            })
        },
      //展品收藏
        collectPro(item) {
            if(!this.userInfo.id) {
                this.$notice({ type: 'danger', message: '请先登录后收藏' });
                return
            }else{
                api.isCollectProduct({
                    exhibition_product_id: item.exhibition_product_id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
            
        },
        cancelCollectPro(item) {
            if(!this.userInfo.id) {
                this.$notice({ type: 'danger', message: '请先登录后收藏' });
                return
            }else{
                api.noCollectProduct({
                    exhibition_product_id: item.exhibition_product_id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$notify("取消收藏");
                        this.getMarkProduct()
                    }
                });
            }
        },
        //视频
         getMarkVideo() {
            api.getMarkVideo({ exhibition_id: all_exhibition_id }).then((res) => {
                if (res.res === 1) {
                    this.videsList = res.list || [];
                    this.noData = !this.videsList.length;
                }
            });
        },
        play(item, index) {
            this.videoSource.map((item) => (item.playFlag = true));
            this.src = item.url;
            // this.src = item.resource.view_url;
            item.playFlag = false;
            this.activeNum = index;
            this.$refs.videoPlay.play();
        },
        stop(item) {
            this.$refs.videoPlay.pause();
            item.playFlag = true;
        },
         // 收藏视频
        isCollectVideo(item) {
            api.isCollectVideo({
                exhibition_id: all_exhibition_id,
                resource_id: item.resource_id
            }).then((res) => {
                // console.log(res);
                item.is_dir = 1;
                this.$notify({ type: 'success', message: '收藏成功' });
            });
        },
        // 取消视频收藏
        noCollectVideo(item) {
            api.noCollectVideo({
                exhibition_id: all_exhibition_id,
                resource_id: item.resource_id
            }).then((res) => {
                // console.log(res);
                item.is_dir = 0;
                this.$notify("取消收藏");
            });
        },
    },
    components: {
      Headers,
    }
}
</script>

<style lang="scss" scoped>
// @import '~styles/varibles.styl'
.tab-content-wrap{
  margin-top: 10px;
  .product-wrap{
    .exhibitior-wrap{
      &:nth-child(odd){
          margin: .16rem .14rem .16rem 0;
      }
      &:nth-child(even){
          margin: .16rem 0;
      }
      height: 3.4rem;
      width: 3.4rem;
      background: #f2f7ff;
      border: 1px solid #e1e1ed;
      border-radius: 7px;
    .exhibitior-wrap-img{
        width: 3.32rem;
        height: 2.1rem;
        opacity: 1;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            max-width: 100%;
            max-height: 2.1rem;
            object-fit: contain;
            padding: .08rem;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.3rem;
        margin: .24rem .26rem .28rem .22rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .34rem;
            height: .34rem;
            font-size: 13px;
            overflow: hidden; 
            white-space: nowrap; 
            text-overflow: ellipsis;
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            margin-top: .12rem;
            .palce{
                display: flex;
                .palce-icon{
                    width: .24rem;
                    height: .28rem;
                    color: #999999;
                    margin-right: .08rem;
                }
                .palce-name{
                    width: 1.32rem;
                    height: .3rem;
                    color: #999999;
                    font-size: 12px;
                    line-height: .3rem;
                    overflow: hidden; 
                    white-space: nowrap; 
                    text-overflow: ellipsis;
                }
            }
            .store{
                display: flex;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}
  }
}
.videos-wrap{
    &:nth-child(1){
        margin-top: .3rem;
    }
    &:nth-last-child(){
        margin-bottom: .3rem;
    }
    width: 6.9rem;
    height: 4.86rem;
    margin-bottom: .48rem;
    // background: #f2f7ff;
    border-radius: 7px;
    .exhibitior-wrap-img{
        width: 6.92rem;
        height: 4.2rem;
        background: #fff;
        video {
            width: 100%;
            height: 100%;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.3rem;
        margin-top: .24rem;
        // margin: .24rem .28rem .28rem .28rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .42rem;
            height: .42rem;
            font-size: 16px;
            // overflow: hidden; 
            // white-space: nowrap; 
            // text-overflow: ellipsis;
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .palce{
                display: flex;
                .palce-name{
                    // width: 1.32rem;
                    height: .42rem;
                    color: #333;
                    font-size: 16px;
                    line-height: .42rem;
                }
            }
            .store{
                display: flex;
                justify-content: center;
                align-items: center;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                    margin-right: .1rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
} 
/deep/ .mint-tab-item-label{
  font-size: 16px
}   
</style>



// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/collection.vue